import React, { type ReactElement } from 'react'
import { Panel } from './Panel'
import type { PanelProps } from './types'

export const Panels: React.FC<{
  children: ReactElement<PanelProps>[]
}> = ({ children }) => {
  return (
    <>
      {React.Children.map(children, (child, idx) => {
        if (!React.isValidElement(child) || child.type !== Panel) {
          throw new Error('<Tabs.Panels> only accepts <Tabs.Panel> as children')
        }
        return React.cloneElement(child, { index: idx })
      })}
    </>
  )
}
